import Response from "./Response";

export default {
    vapidPublicKey: "",

    init() {
        this.registerServiceWorker();
        $(document).on("change", "#user-push-notifications", (event) => {
            const input = $(event.currentTarget);
            const key = input.attr("key");
            if (!key) return;
            this.vapidPublicKey = key;
            if (input.is(":checked")) this.subscribe(input);
        });
    },

    registerServiceWorker() {
        if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
        navigator.serviceWorker
            .register("/sw.js", { updateViaCache: "none" })
            .then((registration) => {
                registration.update();
                console.log("Service Worker zarejestrowany:", registration);
            })
            .catch((error) => console.error("Błąd rejestracji SW:", error));
    },

    async subscribe(input) {
        try {
            const permission = await Notification.requestPermission();
            if (permission !== "granted") {
                Response.handle({
                    toast: {
                        type: "error",
                        message: "Powiadomienia są blokowane przez urządzenie",
                    },
                });
                input.prop("checked", false);
                return;
            }

            const registration = await navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" });
            console.log("Service Worker zarejestrowany:", registration);
            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: this.urlBase64ToUint8Array(this.vapidPublicKey),
            });
            console.log("Push subskrypcja:", subscription);

            await $.ajax({
                url: "/site/push-subscribe",
                method: "POST",
                contentType: "application/json",
                data: JSON.stringify(subscription),
            })
                .done((response) => Response.handle(response))
                .fail((xhr) => Response.error(xhr));
            console.log("Subskrypcja wysłana do serwera");
        } catch (error) {
            console.error("Błąd subskrypcji push:", error);
        }
    },

    urlBase64ToUint8Array(base64String) {
        const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
        const rawData = window.atob(base64);
        return Uint8Array.from([...rawData].map((character) => character.charCodeAt(0)));
    },

    markButton() {
        const input = $("#user-push-notifications");
        if (!input.length) return;
        if (!("Notification" in window)) {
            input.prop("checked", false).prop("disabled", true);
            return;
        }
        if (Notification.permission === "granted") {
            input.prop("checked", true).prop("disabled", true);
        } else {
            input.prop("checked", false);
        }
    },
};
